import { t } from "i18next";
import { Button, Form, Modal } from "react-bootstrap";
import { useEffect, useState } from "react";
import { Trans } from "react-i18next";
import { deleteTrainingSessionTpl, getTrainingSessionTplSingle } from "../../../../services/training-session-tpl";
import { emptyTrainingSessionTpl, TrainingSessionTpl } from "../../../../interfaces/training-session-tpl";
import { LoadingSpinner } from "../../../general/loading-spinner";

interface CoachTrainingSessionTplDeleteProps {
    id: number;
    onDelete: CallableFunction;
    onClose: CallableFunction;
}

export function CoachTrainingSessionTplDelete(props: CoachTrainingSessionTplDeleteProps) {
    const [trainingSessionTpl, setTrainingTpl] = useState<TrainingSessionTpl>(emptyTrainingSessionTpl);

    const handleDelete = () => {
        deleteTrainingSessionTpl(props.id)
            .then(response => {
                props.onDelete(props.id);
            })
            .catch(error => {
                console.log(error);
            });
    }

    const handleClose = () => {
        props.onClose();
    }

    useEffect(() => {
        getTrainingSessionTplSingle(props.id)
            .then(response => {
                setTrainingTpl(response.data);
            })
            .catch(error => {
                console.log(error);
            });
    }, []);

    return (
        <Modal className="training-tpl-delete-container" show={ true }
            onHide={ handleClose }> 
            <Modal.Header closeButton>
                <Modal.Title>
                    { t("delete_training_session_tpl") }
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                { trainingSessionTpl.id == 0 && 
                    <LoadingSpinner />
                }
                { trainingSessionTpl.id != 0 &&
                    <Form onSubmit={ handleDelete }>
                        <div className="fields">
                            <Trans i18nKey="delete_training_session_tpl_message"
                                values={{
                                    training_session_tpl_name: trainingSessionTpl.name
                                   }} />
                        </div>
                        <div className="actions">
                            <Button type="submit" variant="primary">
                                { t("Delete") }
                            </Button>
                            <Button variant="secondary" onClick={ handleClose }>
                                { t("Close") }
                            </Button>
                        </div>
                    </Form>
                }
            </Modal.Body>
        </Modal>
    );
}
